export interface PilotCrmEmailTemplate {
  id: string;
  name: string;
  subject: string;
  body: string;
}

export const PILOT_CRM_EMAIL_TEMPLATES: PilotCrmEmailTemplate[] = [
  {
    id: 'cold-1',
    name: 'Cold Email #1',
    subject: 'Founding Employer Pilot for {{CompanyName}}',
    body:
      "Hi {{FirstName}},\n\n" +
      "We are inviting a small group of employers to join the FairCare Founding Employer Pilot. " +
      "The pilot helps employers offer transparent, cash-pay healthcare benefits with clear savings.\n\n" +
      "If this is a fit for {{CompanyName}}, I'd love to share a short overview and answer questions. " +
      "Would a 15-minute call this week work?\n\n" +
      "Thanks,\n" +
      "FairCare Team",
  },
  {
    id: 'followup-1',
    name: 'Follow-up #1',
    subject: 'Quick follow-up: FairCare pilot for {{CompanyName}}',
    body:
      "Hi {{FirstName}},\n\n" +
      "Just following up on the FairCare Founding Employer Pilot. " +
      "Happy to share details on pricing, timelines, and what participation looks like.\n\n" +
      "If you'd like, I can send a one-page overview or book a quick call.\n\n" +
      "Thanks,\n" +
      "FairCare Team",
  },
  {
    id: 'breakup',
    name: 'Breakup',
    subject: 'Closing the loop on FairCare',
    body:
      "Hi {{FirstName}},\n\n" +
      "I don't want to crowd your inbox, so I'll close the loop for now. " +
      "If FairCare's Founding Employer Pilot becomes a priority for {{CompanyName}}, " +
      "you can reach me here anytime.\n\n" +
      "Best,\n" +
      "FairCare Team",
  },
];
